import { module } from './store'

export const userExtend = {
  key: 'user',
  store: { modules: [{ key: 'user', module }] },
}

